<template>
<div class="slider" ref="slider">
    <div class="slider-rail"></div>
    <div class="slider-track" :style="{width: width}"></div>
    <div
      class="slider-handle"
      :style="{left: handleLeft}"
      @mouseenter="showSpin(curValue)"
      @mouseleave="hideSpin"
    ></div>
    <div class="slider-spin"
      :class="{visible: spin.visible}"
      :style="{left: spin.left}"
    >
      <span class="slider-current">{{spinValue}}</span>
    </div>
    <div class="slider-step" v-if="showStep">
        <div class="slider-step-dot"
             :class="{whitedot: curValue > i}"
              v-for="(i, key) in values"
              :key="key"
              @mouseenter="showSpin(i)"
              @mouseleave="hideSpin"
              @click="handleClick(i)"
        >
        </div>
    </div>
  </div>
</template>

<script>
let oldSpinLeft = 0

export default {
  name: 'CtSlider',
  props: {
    step: {
      type: Number,
      default: 1
    },
    showStep: {
      type: Boolean,
      default: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 5
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: Number
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data () {
    return {
      curValue: 0,
      spinValue: null,
      offsetWidth: 0
    }
  },
  mounted () {
    this.curValue = this.value
    this.$nextTick(() => {
      this.offsetWidth = this.$refs.slider.offsetWidth
    })
  },
  watch: {
    value () {
      this.curValue = this.value
    }
  },
  computed: {
    spin (old) {
      const value = this.spinValue
      let visible = true
      if (value === null) {
        visible = false
      } else if (value === this.min) {
        oldSpinLeft = '8px'
      } else if (value < this.max) {
        const width = ((value - this.min) / (this.max - this.min)) * (this.offsetWidth - 16)
        oldSpinLeft = `${width + 8}px`
      } else {
        oldSpinLeft = 'calc(100% - 8px)'
      }
      return {
        left: oldSpinLeft,
        visible: visible
      }
    },
    handleLeft () {
      const value = this.curValue
      if (value >= this.max) {
        return 'calc(100% - 8px)'
      } else {
        return this.width
      }
    },
    width () {
      const value = this.curValue
      if (value <= this.min) {
        return '8px'
      } else if (value < this.max) {
        const width = ((value - this.min) / (this.max - this.min)) * (this.offsetWidth - 16)
        return `${width + 8}px`
      } else {
        return '100%'
      }
    },
    values () {
      let res = []
      res.length = (this.max - this.min) / this.step + 1
      for (let i = 0; i < res.length; i++) {
        res[i] = this.min + this.step * i
      }
      return res
    }
  },
  methods: {
    showSpin (i) {
      this.spinValue = i
    },
    hideSpin () {
      this.spinValue = null
    },
    handleClick (i) {
      this.curValue = i
      this.$emit('input', i)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
$rail-h: 6px;
$handle-h: 18px;
$color: $primary;
.slider{
    font-size:14px;
    line-height:14px;
    font-family:SFProText-Medium,SFProText;
    font-weight:500;
    color: $text-secondary;
    position: relative;
    display: inline-block;
    width: 100%;
    vertical-align: middle;
    &-rail{
        width: 100%;
        height: $rail-h;
        background:$hr-color;
        border-radius:$rail-h/2;
    }
    &-track{
        height: $rail-h;
        background: $color;
        border-radius:$rail-h/2;
        position: absolute;
        top: 0;
        transition: width ease .6s;
    }
    &-handle{
        position: absolute;
        top: 0;
        width:$handle-h;
        height:$handle-h;
        background:$color;
        cursor: pointer;
        z-index: 1;
        margin-left: -$handle-h/2;
        margin-top: -6px;
        border-radius:50%;
        transition: left ease .6s;
        &::after{
          content: " ";
          position: absolute;
          width: $handle-h /3 ;
          height:$handle-h /3 ;
          background:rgba(255,255,255,0.6);
          border-radius:50%;
          top: $handle-h / 3;
          left: $handle-h / 3;
        }
    }
    &-spin{
      &.visible{
          opacity: 1;
          transition: all ease .4s;
      }
      opacity: 0;
      transition: opacity ease .8s;
      position: absolute;
      top: -26px;
      height: 20px;
      color: $text-primary;
      box-shadow: 0 4px 12px 0 rgba(35,62,114,.2);
      border-radius: 2px;
      font-size: 12px;
      font-weight: 500;
      padding: 3px 8px;
      transform: translateX(-50%);
      line-height: 14px;
      background: #fff;
      transition: left .6s ease-in-out;
      &::before{
        display: block;
        content: "";
        position: absolute;
        bottom: -6px;
        width: 0;
        height: 0;
        border: 3px solid;
        border-color: #fff transparent transparent transparent;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    &-step{
        display: flex;
        padding: 1px 6px;
        justify-content: space-between;
        position: absolute;
        width: 100%;
        top: 0;
        &-dot{
            cursor: pointer;
            width:4px;
            height:4px;
            border-radius: 2px;
            background:rgba(26,61,94,0.12);
            transition: all ease .6s;
            &.whitedot{
                background:rgba(255,255,255,0.4);
            }
        }
    }
}
</style>
